export const AUTH_TOKENS_KEY = 'authToken';

const safeGet = (storage: Storage | undefined): string | null => {
  try {
    return storage?.getItem(AUTH_TOKENS_KEY) ?? null;
  } catch {
    return null;
  }
};

const safeSet = (storage: Storage | undefined, value: string) => {
  try {
    storage?.setItem(AUTH_TOKENS_KEY, value);
    return true;
  } catch {
    return false;
  }
};

const safeRemove = (storage: Storage | undefined) => {
  try {
    storage?.removeItem(AUTH_TOKENS_KEY);
  } catch {
    // Storage may be disabled in private/restricted browser contexts.
  }
};

const getLocalStorage = () => typeof window !== 'undefined' ? window.localStorage : undefined;
const getSessionStorage = () => typeof window !== 'undefined' ? window.sessionStorage : undefined;

export const getAuthToken = (): string | null => {
  const token = safeGet(getLocalStorage()) || safeGet(getSessionStorage());
  return token ? token.replace(/^Bearer\s+/i, '') : null;
};

export const setAuthToken = (token: string, rememberMe = false) => {
  const primary = rememberMe ? getLocalStorage() : getSessionStorage();
  const secondary = rememberMe ? getSessionStorage() : getLocalStorage();

  safeRemove(secondary);
  if (!safeSet(primary, token)) {
    // Preserve a working session when the preferred storage is unavailable.
    safeSet(secondary, token);
  }
};

export const clearAuthToken = () => {
  safeRemove(getLocalStorage());
  safeRemove(getSessionStorage());
};
